// extracted by mini-css-extract-plugin
export default {"submitButton":"ReportForm__submitButton___yrxPZ"};